import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_align_bottom.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconAlignBottom = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconAlignBottom;
